import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiDenoService } from './api/api-deno.service'

export interface OneGptMessage {
  id: string
  content: {
    message: string
    redirect_url?: string
  }
  role: 'user' | 'assistant'
  created_at: string
}

export interface OneGptConversation {
  id: string
  title: string
  created_at: string
  updated_at: string
}

export interface OneGptConversations {
  conversations: OneGptConversation[]
}

export interface OneGptChatMessages {
  messages: OneGptMessage[]
}

export interface OneGptPromptExamples {
  examples: {
    id: string
    title: string
    content: string
  }[]
}

@Injectable({providedIn: 'root'})
export class AiChatApiService {
  constructor(private apiDenoService: ApiDenoService) {}

  createNewChat(): Observable<OneGptConversation> {
    return this.apiDenoService.post('v2/ai_gen_content/conversations', {})
  }

  deleteChat(chatId: string): Observable<any> {
    return this.apiDenoService.delete(`v2/ai_gen_content/conversations/${chatId}`)
  }

  sendMessage(chatId: string, message: string): Observable<OneGptMessage> {
    return this.apiDenoService.post(`v2/ai_gen_content/conversations/${chatId}/messages`, { content: message })
  }

  getAllConversations(): Observable<OneGptConversations> {
    return this.apiDenoService.get('v2/ai_gen_content/conversations')
  }

  getMessagesByConversationId(conversationId: string, messageId = 0): Observable<OneGptChatMessages> {
    const url = `v2/ai_gen_content/conversations/${conversationId}/messages?limit=20`
    return this.apiDenoService.get(url)
  }

  changeChatTitle(chatId: string, title: string): Observable<any> {
    return this.apiDenoService.put(`v2/ai_gen_content/conversations/${chatId}`, { title })
  }

  getPromptExamples(): Observable<OneGptPromptExamples> {
    return this.apiDenoService.get('v2/ai_gen_content/prompt_examples?limit=4')
  }
} 